let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6gvt1")).then(() => parcelRequire('haKND'));